import {createLogic} from 'redux-logic';
import {applicationStore} from 'App/index';

import {
  wsConnect,
  wsDisconnect,
  wsReconnect,
  wsSuccess,
  wsError,
  wsSubscribe
} from './actions';
import {DEV_MODE} from 'App/util/common/helper';
import {selectors as socketSel} from 'App/util/redux/socket/reducer';
import {wsSetSubscription, wsUnsubscribe} from 'App/util/redux/socket/actions';
import {authLogoutSuccess} from 'App/util/redux/auth/actions';
import settings from 'Root/settings.json';

const wsConnectLogic = createLogic({
  type: [wsConnect],
  cancelType: [
    wsDisconnect,
    authLogoutSuccess
  ],
  latest: true, // take latest only

  processOptions: {
    dispatchReturn: false
  },

  process({action, getState}, dispatch, done) {
    const state = getState();

    if (DEV_MODE) {
      socketSel.client(state).debug = (x) => {
        console.log(x);
      }
    }

    socketSel.client(state).brokerURL = settings.websocket.uri;

    if (DEV_MODE)
      socketSel.client(state).debug = (str) => {
        console.log(str);
      };

    socketSel.client(state).reconnectDelay = 300;
    socketSel.client(state).heartbeatIncoming = 4000;
    socketSel.client(state).heartbeatOutgoing = 4000;

    const user = action.payload.user;
    socketSel.client(state).onConnect = (x) => {
      applicationStore.dispatch(wsSubscribe(user));
    };

    socketSel.client(state).onStompError = (e) => {
      applicationStore.dispatch(wsError(e, user));
    };

    socketSel.client(state).activate();

    done();
  }
});

const wsErrorLogic = createLogic({
  type: [wsError],
  cancelType: [wsSuccess],
  latest: true, // take latest only

  processOptions: {
    dispatchReturn: false
  },

  process({action}, dispatch, done) {
    // aggressive reconnect
    // a lot can be improved here, this is just an example
    const e = action.payload.error;
    console.log(e);
    const user = action.payload.user;
    if (
      e.body.match(/Access refused/g) ||
      e.headers['message'].match(/Lost connection/g)
    ) {
      setTimeout(function () {
        applicationStore.dispatch(wsReconnect(user));
      }, 5 * 1000);
    }

    done();
  }
});

const wsSubscribeLogic = createLogic({
  type: [wsSubscribe],
  cancelType: [authLogoutSuccess],
  latest: true, // take latest only

  processOptions: {
    dispatchReturn: false
  },

  process({action, getState}, dispatch, done) {
    const state = getState();
    const user = action.payload.user;

    const exchange = 'amq.topic';
    const routing_key = '#.user-' + user.user_id + '.#';
    const endpoint = '/exchange/' + exchange + '/' + routing_key;

    const subscription = socketSel.client(state).subscribe(
      endpoint,
      (message) => {
        // generic callback action
        const json = JSON.parse(message.body);
        const key = json.key;
        const payload = json.payload;

        const subjectListener = socketSel.listener(state)[key];

        if (subjectListener !== undefined) {
          const listenerFunctions = Object.values(subjectListener);
          for (let i = 0, len = listenerFunctions.length; i < len; ++i) {
            listenerFunctions[i](payload);
          }
        }
      }
    );

    dispatch(wsSetSubscription(subscription));

    done();
  }
});


const wsUnsubscribeLogic = createLogic({
  type: [wsUnsubscribe],
  latest: true, // take latest only

  processOptions: {
    dispatchReturn: false
  },

  process({action, getState}, dispatch, done) {
    const state = getState();
    socketSel.subscription(state) && socketSel.subscription(state).unsubscribe();

    done();
  }
});


const wsDisconnectLogic = createLogic({
  type: [wsDisconnect],
  // cancelType: [],
  latest: true, // take latest only

  processOptions: {
    dispatchReturn: false
  },

  process({action, getState}, dispatch, done) {
    // just display error
    const state = getState();
    if (socketSel.client(state))
      socketSel.client(state).deactivate();

    done();
  }
});

const wsReconnectLogic = createLogic({
  type: [wsReconnect],
  cancelType: [
    wsDisconnect,
    authLogoutSuccess
  ],
  latest: true, // take latest only

  processOptions: {
    dispatchReturn: false
  },

  process({action, getState}, dispatch, done) {
    const user = action.payload.user;

    // disconnect
    dispatch(wsDisconnect());

    // connect new
    dispatch(wsConnect(user));

    done();
  }
});


export default [
  wsConnectLogic,
  wsDisconnectLogic,
  wsReconnectLogic,
  wsSubscribeLogic,
  wsErrorLogic,
  wsUnsubscribeLogic
]


// WEBPACK FOOTER //
// ./src/util/redux/socket/logic.js